import { useDispatch } from 'react-redux'
import { ColorSwatch, BasicCollapsible, SelectionSet, SelectionSetInput, SelectionSetLabel, ColorSwatches } from '@vp/swan'

import { useFilterOptions } from '~/app/features/Gallery/hooks/useFilterOptions'
import { buildRefinement, refinementAddAndRemove } from '~/app/store/refinement'
import { REFINEMENT_DIMENSION } from 'shared/constants'
import { scrollUpToElement } from '~/app/utils/scrollToElement'
import { galleryHeaderId } from '~/app/features/Gallery/components/Header/ActionHeader/constants'
import { isFilterModalHidden } from '~/app/features/Gallery/components/Header/ActionHeader/components/FilterMenu/utils'
import { useRedirectToL0 } from '~/app/features/Gallery/hooks/RedirectToL0/useRedirectToL0'
import { ThunkDispatch } from '~/app/store/interface'

interface PropTypes {
  filter: State.Filter
}

export const ColorFilter = (props: PropTypes) => {
  const { filter } = props
  const { options, selected, visible } = useFilterOptions(filter as State.AttributeFilter)
  const dispatch = useDispatch<ThunkDispatch>()

  const redirectToL0 = useRedirectToL0()

  const handleSelectedValuesChange = (newSelectedValues: SelectedValues): void => {
    const toAdd: State.Refinement[] = []
    const toRemove: State.Refinement[] = []

    for (const [value, isSelected] of Object.entries(newSelectedValues)) {
      const refinement = buildRefinement(value, REFINEMENT_DIMENSION.ATTRIBUTE)

      ;(isSelected ? toAdd : toRemove).push(refinement)
    }

    if (redirectToL0(toAdd, toRemove)) {
      return
    }

    dispatch(refinementAddAndRemove(toAdd, toRemove))
    if (isFilterModalHidden()) {
      scrollUpToElement(galleryHeaderId)
    }
  }

  return (
    <>
      {!visible && null}
      {visible && (
        <BasicCollapsible aria-label={filter.title} className="filter" collapsibleId={filter.name} heading={filter.title} headingLevel="h4">
          <SelectionSet aria-label={filter.title} selectedValues={selected} variant="multi-select" onSelectedValuesChange={handleSelectedValuesChange}>
            <ColorSwatches>
              {options.map((o) => {
                const color = o.otherProperties?.drawingColor

                return (
                  <SelectionSetInput disabled={o.disabled} key={o.value} value={o.value}>
                    <SelectionSetLabel>
                      <ColorSwatch aria-label={o.title} as="span" primaryColor={color!} title={o.title}>
                        {o.title && <span className="screen-reader-text">{o.title}</span>}
                      </ColorSwatch>
                    </SelectionSetLabel>
                  </SelectionSetInput>
                )
              })}
            </ColorSwatches>
          </SelectionSet>
        </BasicCollapsible>
      )}
    </>
  )
}

ColorFilter.displayName = 'ColorFilter'
